module.exports = __webpack_public_path__ + "./images/unknown.5e9ac7.svg";